<template>
  <div>
    <v-progress-circular indeterminate color="orange-darken-2" v-show="preLoading" :size="70" :width="4"></v-progress-circular>
    <vehicle-form
      :vehicle="vehicle"
      :submit="submit"
      :buttonText="t('edit')"
      :onInput="() => {}"
      :loading="loading"
      v-if="!preLoading"
    />
  </div>
</template>

<script setup lang="ts">
import VehicleForm from './Form.vue'
import Say from '@/utils/Say'
import { defineComponent, ref, computed, onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';
import store from '@/store';
import { vehicleStore } from '@/store/vehicles'
import { useRoute } from 'vue-router';
import sayErrorResponse from '@/mixins/sayErrorResponse'

const { t } = useI18n()
const route = useRoute()

defineComponent({
  VehicleForm
})

const preLoading = ref(true)
const loading = ref(false)

const vehicle = computed(() => {
  store.commit('app.setPageTitle', t('vehicleEdit') + ' ' + vehicleStore.getters.vehicle.name)
  store.commit('app.setBreadcrumbs', [
    { text: t('vehicle', 2), routeName: 'VehiclesList' },
    { text: t('vehicleEdit') + ' ' + vehicleStore.getters.vehicle.name }
  ])
  return vehicleStore.getters.vehicle
})

onBeforeMount(() => {
  vehicleStore.dispatch('fetchVehicle', route.params.id)
    .then(() => {
      preLoading.value = false
    })
})

const submit = () => {
  loading.value = true
  vehicleStore.dispatch('updateVehicle', { id: vehicle.value.id, data: vehicle.value }).then(() => {
    loading.value = false
    Say('success', t('vehicleEditSuccess'))
  }).catch((err: any) => {
    loading.value = false
    sayErrorResponse(err)
  })
}
</script>
